module.exports = __webpack_public_path__ + "static/img/cardbg2.efdd090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardbg2.png
// module id = jZMb
// module chunks = 1